import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { OutsourcingContractSetting } from 'src/entities/OutsourcingContractPdf.entity';
import requestUtil from 'src/utils/request.util';

export const queryKey = 'useOutsourcingContractSettingQuery';
const requestPath = '/api/v4/outsourcing_contract_setting';

const getRecord = async (): Promise<OutsourcingContractSetting> => {
  const response: AxiosResponse<OutsourcingContractSetting> = await axios.get(requestPath);
  return response.data;
};

export const useOutsourcingContractSettingQuery = (selectedCompanyId: number, enabled: boolean) => useQuery({
  queryKey: [queryKey, { selectedCompanyId }],
  queryFn: getRecord,
  staleTime: Infinity,
  enabled: !!selectedCompanyId && enabled
});

export const useMutationOutsourcingContractSetting = () => {
  const queryClient = useQueryClient();

  return {
    create: useMutation({
      mutationFn: () => axios.post(requestPath),

      onSuccess: () => {
        void queryClient.invalidateQueries({
          queryKey: [queryKey]
        });
      }
    }),
    update: useMutation({
      mutationFn: (entity: OutsourcingContractSetting) => axios.put(requestPath, { data: requestUtil.convertKeysToSnakeCase(entity) }),

      onSuccess: () => {
        void queryClient.invalidateQueries({
          queryKey: [queryKey]
        });
      },

      // エラー処理を追加
      onError: (error) => {
        console.error('Update failed:', error);
      }
    }),
  };
};
